import type { IPlan, IShopPlanActive, IShopPlatformPlan, ISubscriptionTrialUsage } from '../types';
import type { ScrollableRef } from '@shopify/polaris';

import { IPricingModal } from '../types';
import { create } from 'zustand';

export interface IPricingStoreState {
  modalPricingInstantRef: ScrollableRef | null;
  openModal: IPricingModal;
  listPlans: IPlan[] | null;
  shopPlatformPlanActive: IShopPlanActive | null;
  /**
   * @deprecated
   */
  shopPlatformPlans: IShopPlatformPlan[] | null;
  subscriptionTrialUsages: ISubscriptionTrialUsage[] | null;
  isFetchedShopPlatformPlanActive: boolean;
  isFetchedShopPlatformPlans: boolean;
  isFetchedSubscriptionTrialUsage: boolean;
}

export interface IPricingStoreActions {
  setModalPricingInstantRef: (value: ScrollableRef | null) => void;
  setListPlans: (value: IPlan[]) => void;
  setShopPlatformPlanActive: (value: IShopPlanActive) => void;
  /**
   * @deprecated
   */
  setShopPlatformPlans: (value: IShopPlatformPlan[]) => void;
  setSubscriptionTrialUsage: (value: ISubscriptionTrialUsage[]) => void;
  setIsFetchedShopPlatformPlanActive: (value: boolean) => void;
  setIsFetchedShopPlatformPlans: (value: boolean) => void;
  setIsFetchedSubscriptionTrialUsage: (value: boolean) => void;
  setOpenModal: (value: IPricingModal) => void;
}

export const usePricingStore = create<IPricingStoreState & IPricingStoreActions>()((set) => ({
  openModal: IPricingModal.NONE,
  listPlans: null,
  shopPlatformPlanActive: null,
  shopPlatformPlans: null,
  subscriptionTrialUsages: null,
  isFetchedSubscriptionTrialUsage: false,
  isFetchedShopPlatformPlanActive: false,
  isFetchedShopPlatformPlans: false,
  modalPricingInstantRef: null,

  setListPlans: (val: IPlan[]) => {
    set(() => ({ listPlans: val }));
  },
  setShopPlatformPlanActive: (val: IShopPlanActive) => {
    set(() => ({ shopPlatformPlanActive: val }));
  },
  setShopPlatformPlans: (val: IShopPlatformPlan[]) => {
    set(() => ({ shopPlatformPlans: val }));
  },
  setSubscriptionTrialUsage: (val: ISubscriptionTrialUsage[]) => {
    set(() => ({ subscriptionTrialUsages: val }));
  },
  setIsFetchedShopPlatformPlanActive: (val: boolean) => {
    set(() => ({ isFetchedShopPlatformPlanActive: val }));
  },
  setIsFetchedShopPlatformPlans: (val: boolean) => {
    set(() => ({ isFetchedShopPlatformPlans: val }));
  },
  setIsFetchedSubscriptionTrialUsage: (val: boolean) => {
    set(() => ({ isFetchedSubscriptionTrialUsage: val }));
  },
  setModalPricingInstantRef: (val: ScrollableRef | null) => {
    set(() => ({ modalPricingInstantRef: val }));
  },
  setOpenModal: (val: IPricingModal) => {
    set(() => ({ openModal: val }));
  },
}));
